
import { computed, defineComponent } from "vue";
import SingleFocusLayout from "@/layouts/page-layouts/single-focus-layout.vue";
import BaseLoader from "@/ui-library/base-loader/base-loader.vue";
import BaseTransitionFade from "@/ui-library/base-transition/base-transition-fade.vue";
import InformationIcon from "@/ui-library/icons/information-icon.vue";
import { useStore } from "@/store";
import ReportIssueButton from "@/pages/report-issue/components/report-issue-button.vue";
import MainAuthenticationLayout from "./layouts/main-authentication-layout.vue";

export default defineComponent({
  setup() {
    const store = useStore();
    return {
      isAuthLoading: computed(() => store.getters.isAuthLoading),
    };
  },
  components: {
    SingleFocusLayout,
    BaseLoader,
    BaseTransitionFade,
    ReportIssueButton,
    InformationIcon,
    MainAuthenticationLayout,
  },
});
